import React from 'react';
import { inject, observer } from 'mobx-react';
import { languageList } from '@/common/js/qiankunConfig';
import {
  changeApiEnv, getPersonInfo, changeStatusV2, changeSubStatus
} from '@/common/js/api'
import { changeUrlSearchParam, deleteUrlSearchParam, setCookie, getCookie } from '@/common/utils/commonFunc'
import { Dropdown, Menu, message } from 'antd';
import './index.less'

// SiderContext 是内部属性 未来不保证一直存在
// issue: https://github.com/ant-design/ant-design/issues/20820
import MixinsContext from "@/common/utils/mixinsContext";
import { SiderContext } from 'antd/es/layout/Sider';
import CommonStore from '@/stores/commonStore';
import IconFont from '@/common/utils/iconfont'
import { needJumpTo } from '@/common/js/const';

const SiderMixinsContext: any = MixinsContext(SiderContext);
const { SubMenu } = Menu;

interface UserInfoProps {
  CommonStore?: typeof CommonStore;
  collapsed: boolean;
}

@inject('CommonStore')
@observer
class UserInfo extends React.Component<UserInfoProps, any> {
  constructor(props: UserInfoProps) {
    super(props);
    this.state = {
      currCountry: getCookie('canonical_country_code') || localStorage.getItem('canonical_country_code'),
      currLang: getCookie('lang') || localStorage.getItem('lang') || "en-US",
      organization_id: getCookie('organization_id') || localStorage.getItem('organization_id'),
      userInfoVisible: false,
      organizationList: props.CommonStore!.organizationList,
      envList: props.CommonStore!.envList,
      moduleCountry: props.CommonStore!.moduleCountry,
      allCountry: props.CommonStore!.allCountry,
      currCountryName: '',
      currOffsetName: '',
      infoData: {},
    };
  }

  componentDidMount() {
    // 新国家&时区接口
    this.setCurrCountry()
    this.setCurrModuleCountry()
    this.setPersonInfo();
  }
  setPersonInfo = () => {
    getPersonInfo().then(res => {
      if (res && res.data) {
        this.setState({
          infoData: res.data
        });
      }
    });
  };

  // 获取模板国家列表
  setCurrModuleCountry = () => {
    this.state.moduleCountry.forEach((item: { code: string; name: string; }) => {
      if (item.code === this.state.currCountry) {
        this.setState({
          currCountryName: item.name,
          currOffsetName: ''
        })
      }
    })
  }

  // 获取国家及时区列表
  setCurrCountry = () => {
    this.state.allCountry.forEach((item: { code: string; name: string; offsetName: string; }) => {
      if (item.code === this.state.currCountry) {
        this.setState({
          currCountryName: item.name,
          currOffsetName: item.offsetName
        })
      }
    })
  }


  // 切换环境
  handleUserInfoItemClick = ({ key }: { key: React.Key }) => {
    if (key !== 'logout') {
      changeApiEnv(key).then((res: any) => {
        if (res) {
          message.error(res.error || res.errors || '切换环境接口执行失败')
        }
      })
    }
  }

  // 选择国家
  handleCountryItemClick = (subItem: { code: string; name?: string; offsetName?: string; jumpTo?: string; offset?: number; countryTelId?: number; }) => {
    if (subItem.code === this.state.currCountry) {
      return
    }
    if (window.location.host !== subItem.jumpTo && needJumpTo) {
      let searchStr = changeUrlSearchParam('canonical_country_code', subItem.code)
      window.open(`//${subItem.jumpTo}${window.location.pathname}${searchStr}`, "_blank")
      return
    }
    let currCountry = subItem.code
    let utc_offset = subItem.offset
    this.setState({
      currCountry,
    }, () => {
      // 清除国家码cookie
      // localStorage.setItem('canonical_country_code', this.state.currCountry)
      // setCookie('canonical_country_code', this.state.currCountry, 24)
      // localStorage.setItem('utc_offset', String(utc_offset))
      // setCookie('utc_offset', utc_offset, 24)
      setCookie('countryTelId', subItem.countryTelId, 24)

      // 消除apollo后删除 Start
      // 跳转apollo 旧方舟localstorage用
      let position: { canonical_country_code: string; countryTelId?: number; offset?: number } = { canonical_country_code: '' }
      position.canonical_country_code = this.state.currCountry
      position.countryTelId = subItem.countryTelId
      position.offset = utc_offset
      localStorage.setItem(`position_${getCookie('userid')}`, JSON.stringify(position))
      if (getCookie('currentOnlineChatStatus') === '121' &&
      (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard'))) {
        // if (this.props.CommonStore!.workStatus === 2) {
          changeStatusV2({
            workbenchType: 2,
            targetStatus: 121,
          });
        // } else {
        //   const param = {
        //     type: 2,
        //     operationPosition: 1,
        //     targetStatus: 121
        //   }
        //   changeSubStatus(param);
        // }
      }
      // end
      let url = window.location.href
      let jumpUrl = deleteUrlSearchParam(window.location.href, 'organization_id')
      jumpUrl = deleteUrlSearchParam(jumpUrl, 'canonical_country_code')
      if (url === jumpUrl) {
        window.location.reload();
      } else {
        window.location.href = jumpUrl
      }
    })
  }


  // 选择业务线
  handleOrganizationClick = (item: string, name: string) => {
    if (item === this.state.organization_id) {
      return
    }
    let cCode = {
      organizationTitle: name,
      organizationId: item
    }
    localStorage.setItem(`cCode_${getCookie('userid')}_${this.state.currCountry}`, JSON.stringify(cCode))
    setCookie('organization_id', item, 24)
    localStorage.setItem('organization_id', item)
    if (getCookie('currentOnlineChatStatus') === '121' &&
      (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard'))) {
        // if (this.props.CommonStore!.workStatus === 2) {
          changeStatusV2({
            workbenchType: 2,
            targetStatus: 121,
          });
        // } else {
        //   const param = {
        //     type: 2,
        //     operationPosition: 1,
        //     targetStatus: 121
        //   }
        //   changeSubStatus(param);
        // }
    }
    let jumpUrl = deleteUrlSearchParam(window.location.href, 'organization_id')
    jumpUrl = deleteUrlSearchParam(jumpUrl, 'canonical_country_code')
    window.location.href = jumpUrl
    window.location.reload();
  }

  // 选择语言
  handleLanguageItemClick = ({ key }: any) => {
    this.setState({
      currLang: key
    }, () => {
      localStorage.setItem('lang', this.state.currLang)
      setCookie('lang', this.state.currLang, 24)
      if (~this.state.currLang.indexOf('-')) {
        let t = this.state.currLang.split('-').join('_')
        setCookie('javaLang', t, 24)
      }
      let searchStr = changeUrlSearchParam('lang', key)
      window.location.search = searchStr
    })
  }

  // 设置列表样式
  handleVisibleChange = (flag: boolean) => {
    this.setState({ userInfoVisible: flag })
  }

  // menu点击
  handleMenuClick = () => {
    this.setState({ userInfoVisible: false });
  }

  render() {
    const TEXTS = this.props.CommonStore!.curLocales || {}
    return (
      <div className='user bottom-icon'>
        <Dropdown
          trigger={['hover']}
          onVisibleChange={this.handleVisibleChange}
          overlayClassName={`USER_INFO ${this.props.collapsed ? '' : 'open'}`}
          visible={this.state.userInfoVisible}
          placement='topRight'
          overlay={(
            <div className='settings'>
              <div className='user-name-container'>
                <div>
                  <IconFont type={'icon-User'} className="user-name-icon" />
                  <span className="user-name">{getCookie('user_name')}</span>
                </div>
                {/* 岗位名称 */}
                <div className='user-name-info'>
                  <span className='user-name-info-title'>{TEXTS['CS_system_Name_of_QEFT']}</span>
                  <span className='user-name-info-content'>{this.state.infoData.positionTitle}</span>
                </div>
                {/* 部门信息 */}
                <div className='user-name-info'>
                  <span className='user-name-info-title'>{TEXTS['CS_system_Sectoral_information_JizK']}</span>
                  <span className='user-name-info-content'>{this.state.infoData.deptName}</span>
                </div>
                {/* 当前技能类型 */}
                <div className='user-name-info'>
                  <span className='user-name-info-title'>{TEXTS['CS_System_lIGK_Ukwr']}</span>
                  <span className='user-name-info-content'>{this.state.infoData.dailySkillType &&
                  this.state.infoData.dailySkillType.length > 0 && this.state.infoData.dailySkillType.join('，')}</span>
                </div>
                {/*	培训过技能类型 */}
                <div className='user-name-info'>
                  <span className='user-name-info-title'>{TEXTS['CS_System_ZQjn_eCbz']}</span>
                  <span className='user-name-info-content'>{this.state.infoData.serviceableSkillType &&
                  this.state.infoData.serviceableSkillType.length > 0 && this.state.infoData.serviceableSkillType.join('，')}</span>
                </div>
              </div>
              <SiderMixinsContext value={{ siderCollapsed: false }}>
                <Menu
                  onClick={this.handleMenuClick}
                  selectedKeys={[]}
                  triggerSubMenuAction='hover'
                  theme='light'
                  mode='vertical'
                >
                  {/* language */}
                  <SubMenu key="sub3" popupClassName='user-info-submenu language-submenu'
                    popupOffset={[0, -108]}
                    title={
                      <span>
                        <span>{TEXTS['CS_1_Languages_hMbf']}</span>
                        <span className='chosen-item'>{languageList[this.state.currLang]}</span>
                      </span>
                    }>
                    {
                      Object.keys(languageList).map((item) => {
                        return (
                          <Menu.Item key={item} onClick={this.handleLanguageItemClick} className={item === this.state.currLang ? 'curr-item' : ''}>
                            <span>{languageList[item]}</span>
                          </Menu.Item>)
                      })
                    }
                  </SubMenu>

                  {/* permissions */}
                  {this.props.CommonStore!.permissionsObj.non_customer_service && (
                    <SubMenu key="sub5" popupClassName='user-info-submenu'
                      popupOffset={[0, -10]}
                      title={
                        <span>{TEXTS['CS_1_Permissions_MuvF']}</span>
                      }>
                      <Menu.Item key="9">
                        <a href={'https://upm.didiglobal.com/upm2-static/main/permission-valid'} target="blank">
                          {TEXTS['CS_1_View_Current_IOCz']}
                        </a>
                      </Menu.Item>
                      <Menu.Item key="10">
                        <a href={'https://upm.didiglobal.com/upm2-static/main/newapply'} target="blank">
                          {TEXTS['CS_1_Upgrade_current_dlbi']}
                        </a>
                      </Menu.Item>
                    </SubMenu>
                  )}
                </Menu>
              </SiderMixinsContext>
              <div className='sign-out' onClick={() => {
                const params = {
                  targetStatus: 1000,
                  misName: this.props.CommonStore?.UserInfo.username,
                  javaLang: getCookie("lang").replace("-", "_")
                };
                // if (this.props.CommonStore!.workStatus === 2) {
                  changeStatusV2({
                    workbenchType: 1,
                    ...params,
                  }).then((res: any) => {
                    if (res.status === 0) {
                      changeStatusV2({
                        workbenchType: 2,
                        ...params,
                      }).then((res: any) => {
                        if (res.status === 0) {
                          changeStatusV2({
                            workbenchType: 3,
                            ...params,
                          }).then((res: any) => {
                            if (res.status === 0) {
                              window.location.replace('/cross/sso/logout');
                            }
                          })
                        }
                      })
                    }
                  })
                // } else {
                //   window.location.replace('/sso/logout');
                // }
              }}>
                {/* <a href='/sso/logout'>{TEXTS['CS_1_Log_in_sMmF']}</a> */}
                <a>{TEXTS['CS_1_Log_in_sMmF']}</a>
              </div>
            </div>
          )}>
          <span className='userinfo' onClick={e => e.preventDefault()}>
            <IconFont type={'icon-User'} />
            {/* <i className={`user-flag ${this.state.currCountry}`}></i> */}
          </span>
        </Dropdown>
      </div>
    )
  }
}

export default UserInfo

